import React from 'react';
import TopicRollup from 'components/dashboard/rollups/topic/TopicRollup';
import withLoading from 'components/dashboard/rollups/topic/withLoading';
import {
  fetchProfileUsageByTriggerRuleId,
  topicRollupData,
} from 'components/dashboard/rollups/topic/common';
import ExecDashboardSource from 'sources/ExecDashboardSource';
import {shouldUpdate} from 'components/StatsPage2.utils';

/**
 * Renders the topic metrics for an exec's dashboard. Includes all teams in the account.
 */
class AdminTopicRollup extends React.PureComponent {
  render() {
    return <TopicRollup {...this.props} />;
  }
}

const promiseProducer = async props => {
  const {startDate, endDate} = props;
  const teams = await ExecDashboardSource.getTeamsInAccount();
  const teamIds = teams.toList().map(t => t.id);
  const triggerRules = await ExecDashboardSource.getDashboardTriggers();
  return Promise.all([
    Promise.resolve(triggerRules),
    ExecDashboardSource.getConversations({
      teams: teamIds,
      startDate,
      endDate,
    }),
    // StatsPage2 also fetches this, but we don't have any good way of hooking in to make sure it's
    // ready.
    Promise.resolve(teams),
    ExecDashboardSource.getTopicMetrics({
      teams: teamIds,
      startDate,
      endDate,
    }),
    fetchProfileUsageByTriggerRuleId(triggerRules.keySeq()),
  ]);
};

export default withLoading({
  WrappedComponent: AdminTopicRollup,
  promiseProducer,
  finalStateProducer: ([
    triggerIdToName,
    conversations,
    teams,
    metrics,
    profileUsageByTriggerRuleId,
  ]) => ({
    conversations,
    loading: false,
    loadingError: false,
    profileUsageByTriggerRuleId,
    summaryStats: topicRollupData(triggerIdToName, conversations, metrics),
    teams: teams.valueSeq().toList(),
    triggerIdToName,
  }),
  shouldReload: (prevProps, props) => shouldUpdate(prevProps, props, false, true, false),
});
